import { render, staticRenderFns } from "./ScenkonstOtPerformanceListing.vue?vue&type=template&id=ef4c4162&"
import script from "./ScenkonstOtPerformanceListing.vue?vue&type=script&lang=ts&"
export * from "./ScenkonstOtPerformanceListing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports